/**
 * Occult motifs as inline SVG, recolourable via `currentColor` (spec §8).
 *
 * Watermarks render at 0.05–0.06 opacity so they read as texture, not decoration
 * — spec §2, "ornamentation lives in the margins".
 */

export interface SigilProps {
  size?: number
  className?: string | undefined
  /** Marks the sigil as a background texture: very low opacity, never announced. */
  watermark?: boolean
}

function sigilStyle(watermark: boolean) {
  return watermark ? { opacity: 0.055 } : undefined
}

/** Five-pointed star in a circle. The app's identity mark. */
export function Pentacle({ size = 24, className, watermark = false }: SigilProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      style={sigilStyle(watermark)}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="16"
        cy="16"
        r="14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.9"
      />
      <path
        d="M16 5 L24.3 30.5 L2.6 14.7 L29.4 14.7 L7.7 30.5 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** Concentric summoning circle — the dice screen's motif, reused as page texture. */
export function ArcaneCircle({ size = 240, className, watermark = true }: SigilProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 240 240"
      className={className}
      style={sigilStyle(watermark)}
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="120" cy="120" r="112" />
        <circle cx="120" cy="120" r="94" strokeDasharray="2 8" />
        <circle cx="120" cy="120" r="70" />
        <path d="M120 22 L204 170 L36 170 Z" />
        <path d="M120 218 L36 70 L204 70 Z" />
      </g>
    </svg>
  )
}
